// Sign-out with unsynced work: offer sync now, export, or explicit discard. Never silently deletes edits.
import { reactive } from 'vue';

export const signOutGuard = reactive({ open: false, pending: 0, busy: false, error: '', actions: null as null | { sync(): Promise<number>; exportWork(): Promise<void>; discardAndSignOut(): Promise<void>; signOut(): Promise<void> } });

export async function requestSignOut(pending: number, actions: NonNullable<typeof signOutGuard.actions>): Promise<void> {
  if (pending === 0) { await actions.signOut(); return; }
  Object.assign(signOutGuard, { open: true, pending, busy: false, error: '', actions });
}
